import { CALL_API } from "admin/middlewares/api";
import { get_user_data_for_account_id } from "../actions";

export const ORGANISATION_ADD_REQUEST = "ORGANISATION_ADD_REQUEST";
export const ORGANISATION_ADD_SUCCESS = "ORGANISATION_ADD_SUCCESS";
export const ORGANISATION_ADD_ERROR = "ORGANISATION_ADD_ERROR";

export function add_company(
  orgNo,
  name,
  address,
  postalCode,
  city,
  country,
  person,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/organisations/Add",
      authenticatedRequest: true,
      method: "POST",
      data: {
        OrgNo: orgNo,
        Name: name,
        StreetAddress: address,
        PostalCode: postalCode,
        City: city,
        Country: country,
        OwnerPersonId: person,
      },
      types: [
        ORGANISATION_ADD_REQUEST,
        { method: successOnAddedOrganisation },
        ORGANISATION_ADD_ERROR,
      ],
    },
  };
}

function successOnAddedOrganisation(data, response) {
  return (dispatch, getState) => {
    const state = getState();
    const currentUser = state.users.currentUser.Id;
    dispatch({
      type: ORGANISATION_ADD_SUCCESS,
      response,
    });

    dispatch(get_user_data_for_account_id(currentUser));
  };
}

export const ORIGINATOR_ADD_REQUEST = "ORIGINATOR_ADD_REQUEST";
export const ORIGINATOR_ADD_SUCCESS = "ORIGINATOR_ADD_SUCCESS";
export const ORIGINATOR_ADD_ERROR = "ORIGINATOR_ADD_ERROR";

export function add_originator(data) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/originators/add",
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        ORIGINATOR_ADD_REQUEST,
        ORIGINATOR_ADD_SUCCESS,
        ORIGINATOR_ADD_ERROR,
      ],
    },
  };
}
